import { useEffect, useState } from "react";
import { useCurrentOrganisationId } from "../../../../../services/local/organisationContext/OrganisationContextModel";
import { TrainingCoursesListViewModel } from "./TrainingCoursesListView_model";
import { observer } from "mobx-react-lite";
import { PositionedSpinner } from "../../../../../components/ui/PositionedSpinner";
import { useParams } from "react-router-dom";
import { TrainingCoursesGrid } from "../../../../../core/grids/builder/directorBuilder/grids/TrainingCoursesGrid/TrainingCoursesGridView_view";

export const TrainingCoursesListView: React.FC = observer(() => {
  let organisationId = useCurrentOrganisationId();
  let { projectId } = useParams<{ projectId: string }>();
  const [model, setModel] = useState(() => new TrainingCoursesListViewModel(organisationId, +projectId));

  useEffect(() => {
    model.onMount();
  }, [model]);

  useEffect(() => {
    setModel(new TrainingCoursesListViewModel(organisationId, +projectId));
  }, [organisationId, projectId]);

  if (model.isLoading) {
    return <PositionedSpinner />;
  }

  return (
    <div className=" insight-tab-content__space-filler" style={{ height: "100%" }}>
      <TrainingCoursesGrid
        data={model.trainingCourseData}
        gridToolbarType="base"
        isLoading={model.isLoading}
        onFieldUpdate={model.loadTrainingCourseData}
        refreshDataHandler={model.loadTrainingCourseData}
      />
    </div>
  );
});
